/* The country a phone field opens on, and reads an untyped local number as. */
export const DEFAULT_PHONE_COUNTRY = "SA";

/* Listed above the alphabetical list in the country picker. */
export const PREFERRED_PHONE_COUNTRIES = [
  "SA",
  "AE",
  "KW",
  "QA",
  "BH",
  "OM",
  "EG",
];

/* The two option groups of the country picker. */
export const COUNTRY_GROUP_KEY = {
  SUGGESTED: "suggested",
  ALL: "all",
};

/* Height of the country picker's virtual list, in px. */
export const COUNTRY_LIST_HEIGHT = 288;

/* The status `Form.Item.useStatus()` reports while a rule is failing. */
export const STATUS_ERROR = "error";

/*
 * A trigger of our own: `Form.Item` injects a handler for every name listed in
 * `validateTrigger`, so the field can ask to be revalidated without knowing its
 * name path. It fires once the number becomes valid, clearing a shown error.
 */
export const REVALIDATE_TRIGGER = "onRevalidate";
